function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "GoBack_Hover",
  transform: "rotate(180 20.5 20.5)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_132",
  className: "rectangle",
  "data-name": "Rectangle 132",
  width: 40,
  height: 40,
  rx: 8,
  fill: "#b0d4e6",
  stroke: "#98c3d9",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_121",
  className: "arrow",
  "data-name": "Path 121",
  d: "M15.5 10.501l11 10-11 10",
  fill: "none",
  stroke: "#002d56",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 3
}));

function SvgGoBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiIgdmlld0JveD0iMCAwIDQyIDQyIj4KICA8ZyBpZD0iR29CYWNrX0hvdmVyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MSA0MSkgcm90YXRlKDE4MCkiPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xMzIiIGNsYXNzPSJyZWN0YW5nbGUiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDEzMiIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iOCIgZmlsbD0iI2IwZDRlNiIgc3Ryb2tlPSIjOThjM2Q5IiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzEyMSIgY2xhc3M9ImFycm93IiBkYXRhLW5hbWU9IlBhdGggMTIxIiBkPSJNMjc2LjcsMTUzLjg3bDEwLTExLDEwLDExIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjkuMzcgLTI2Ni4xOTkpIHJvdGF0ZSg5MCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMmQ1NiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjMiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };